var effector = {
    listenerConfigs: [],
};
function dispose(listener) {
    effector.listenerConfigs = effector.listenerConfigs.filter(function (config) { return config.listener !== listener; });
}
function connect(listener, once) {
    effector.listenerConfigs.push({ listener: listener, once: once });
    return function () { return dispose(listener); };
}
function run() {
    effector.listenerConfigs.forEach(function (config) {
        config.listener();
        if (config.once) {
            dispose(config.listener);
        }
    });
}
export default {
    connect: connect,
    run: run,
    dispose: dispose,
};
